import Image from "next/image";

function AppStoreWhiteLogo({ redirectUrl }) {
  return (
    <a href={redirectUrl} target="_blank" rel="noreferrer">
      <button>
        <Image
          src="/assets/logo/app-store-white.svg"
          width={144}
          height={44}
          alt="app-store"
        />
      </button>
    </a>
  );
}

export default AppStoreWhiteLogo;
